<template>
  <f7-page @page:beforein="beforein">
    <navbar :text="$t('AnalysisGis.title')" />
    <GisGrid
      v-if="loaded"
      :custom-store="customStore"
    />
    <f7-row v-if="loaded && sectorIdLeftComparator !== '' && sectorIdRightComparator !== ''">
      <f7-col />
      <f7-col>
        <f7-button
          class="dx-btn-success"
          raised
          type="success"
          styling-mode="contained"
          @click="compare()"
        >
          {{ $t("AnalysisGis.compare") }}
        </f7-button>
      </f7-col>
    </f7-row>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import navbar from '../../components/NavBar.vue';
import GisGrid from '../../components/analisys/gis/gisGrid/index.vue';

export default {
  name: 'GisGridPage',
  components: {
    navbar,
    GisGrid,
  },
  data() {
    return {
      loaded: false,
      customStore: null,
    };
  },
  computed: {
    ...mapState('Plantation', ['plantations', 'plantationsFormatted', 'sectorIdLeftComparator', 'sectorIdRightComparator']),
  },
  methods: {
    async beforein() {
      this.$fa.setScreenName('Análisis > Gis');
      this.$f7.preloader.show();
      try {
        this.customStore = await this.getStore({ type: 'contactPlantation' });
        this.setSectorIdLeftComparator('');
        this.setSectorIdRightComparator('');
        this.resetComparatorsPlantationId();
        this.resetComparatorsPlantationArea();
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(`${error}`),
            width: 550,
          },
          'error',
          3000,
        );
      } finally {
        this.$f7.preloader.hide();
        this.loaded = true;
      }
    },
    getStatusCampaign(initDate, endDate) {
      if (moment(this.actualDate).isBetween(initDate, endDate)) {
        return this.$t('status_campania_active');
      } if (endDate < this.actualDate) {
        return this.$t('status_campania_end');
      }
      return this.$t('status_campania_pending');
    },
    compare() {
      this.$fa.logEvent('analisis_gis_comparar', {
        content_type: 'button',
        description: 'Evento ocurre en la vista de Análisis/gis y pulsamos el boton comparar',
      });
      this.$f7.views.main.router.navigate('/gisComparator/', { reloadCurrent: true });
    },
    ...mapActions('Plantation', ['fetchPlantations', 'setPlantationsFormatted', 'setSectorIdLeftComparator', 'setSectorIdRightComparator', 'resetComparatorsPlantationId', 'resetComparatorsPlantationArea']),
    ...mapActions('Pagination', ['getStore']),

  },
};
</script>
